export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7298.7198c241.jpg";